// extracted by mini-css-extract-plugin
export var modal = "_42-0";